import messages from './cambiar-password-modal-translations';
import * as $ from 'jquery';
import { CambiarPasswordService } from './services/cambiarPasswordService';

export default {
    name: 'instamapsCambiarPasswordModal',
    i18n: {
        messages,
    },
    data() {
        return {
            form: {
                pass: '',
                confirmpass: '',
                oldpass: '',
            }
        };
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#cambiar-password-modal').addClass('animate-flex-modal');
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#cambiar-password-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        updatePassword: function(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                    CambiarPasswordService.updatePassword(this.form.oldpass, this.form.pass).then((response) => {
                        if (response.status==="OK") {
                            this.dismiss();
                            this.$emit('ok', {title: this.$t('title'), message: this.$t('messageOk')});
                        }else{
                            this.dismiss();
                            this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                        }
                    }).catch(() => {
                        this.dismiss();
                        this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                    });
                }
            });
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/cambiar-password-modal/cambiar-password-modal.js